import autobg from 'autobg.macro';
import React from 'react';
import vw from 'rpf/un/vw';
import styled from 'styled-components';

const Wrap = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${vw(78)};
  height: ${vw(78)};
  background-color: #4460b7;
  border-top-right-radius: ${vw(20)};
`;

const Icon = styled.div`
  ${autobg('assets/img/home/close.png')}
`;

const CloseBtn = props => {
  return (
    <Wrap onClick={props.onClick}>
      <Icon></Icon>
    </Wrap>
  );
};

export default CloseBtn;
